export default {
	state: {
		parceiroSelecionado: {}
	},
	getters: {
		"parceiroSelecionado": state => state.parceiroSelecionado
	},
	mutations: {
		setParceiroSelecionado(state, payload) {
			state.parceiroSelecionado = payload
		}
	},
	actions: {
		atualizarEstadoParceiroSelecionado({ commit }, payload) {
			commit('setParceiroSelecionado', payload)
		}
	}
};